import { Tag, Popover } from "antd";

function TagList({ items, color, limit = 2 }) {
  if (!items?.length) return <span style={{ color: '#bbb' }}>-</span>;
  const visible = items.slice(0, limit);
  const hidden = items.slice(limit);
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
      {visible.map((item) => (
        <Tag key={item._id} color={color} style={{ margin: '2px 4px 2px 0' }}>{item.en_name}</Tag>
      ))}
      {hidden.length > 0 && (
        <Popover
          content={
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, maxWidth: 260 }}>
              {hidden.map((item) => (
                <Tag key={item._id} color={color} style={{ margin: '2px 4px 2px 0' }}>{item.en_name}</Tag>
              ))}
            </div>
          }
          title={null}
          trigger="hover"
        >
          <Tag style={{ margin: '2px 0', cursor: 'pointer' }}>+{hidden.length} more</Tag>
        </Popover>
      )}
    </div>
  );
}

export default TagList;
